export default __webpack_public_path__ + "media/images/user_photos/28-df933b397a2f0ced61b302892b4a72f5.jpg";